import { PayPalButtons } from "@paypal/react-paypal-js";
import axios from "axios";
import { API_BASE_URL } from "../../global";

const PayPalButtonUI = ({ amount, currency, tokens, userId = null, planId = null, onSuccess, onFailure, onButtonClick }) => {
  const displayAmount = parseFloat(amount || 0).toFixed(2);

  const sendFailureToBackend = async (reason, status = "failed") => {
    try {
      await axios.post(`${API_BASE_URL}upgrade_plan`, {
        user_id: userId,
        upgrade_status: 0, // 0 - error
        fk_token_plan_id: planId,
        upgrade_amount: displayAmount,
        upgrade_tokens: tokens,
        upgrade_method: "PayPal",
        upgrade_message: JSON.stringify(reason)
      });
    } catch (err) {
      console.error("Backend failure logging error:", err.message);
    }
  };

  return (
    <>
      {parseFloat(displayAmount) > 0 ? (
        <PayPalButtons
          style={{ layout: "vertical", color: "blue", shape: "rect" }}
          onClick={() => {
            // Called before popup opens
            onButtonClick?.();
          }}
          createOrder={(data, actions) => {
            return actions.order.create({
              purchase_units: [
                {
                  amount: {
                    value: displayAmount,
                    currency_code: currency,
                  },
                },
              ],
            });
          }}
          onApprove={async (data, actions) => {
            try {
              const details = await actions.order.capture();
              const paymentMethod =
                details?.payment_source?.paypal?.email_address
                  ? "PayPal Account"
                  : details?.payment_source?.card?.brand
                  ? `Card (${details.payment_source.card.brand})`
                  : "Paypal";

              await axios.post(`${API_BASE_URL}upgrade_plan`, {
                orderID: data.orderID,
                payerID: data.payerID,
                amount: displayAmount,
                currency: currency,
                user_id: userId,
                upgrade_status: 1, // 1- success, 0 - error
                fk_token_plan_id: planId,
                upgrade_amount: displayAmount,
                upgrade_tokens: tokens,
                upgrade_method: paymentMethod,
                upgrade_message: JSON.stringify(details)
              });

              onSuccess?.({
                status: "Success",
                orderID: data.orderID,
                amount: displayAmount,
                currency: currency,
              });
            } catch (error) {
               const errorMessage = error?.response?.data?.message || error.message;
              await sendFailureToBackend(error?.response?.data?.message || error.message);
              onFailure?.({ status: "failed", reason: errorMessage });
            }
          }}
          onError={async (err) => {
              const reason = err?.message || "Unknown error occurred";
              
              // Skip logging for "window closed" error
              if (reason.includes("Window closed before response")) {
                console.warn("User closed the PayPal popup window.");
                onFailure?.({ status: "closed", reason: "User closed the PayPal popup window" });
                return;
              }

              // Log other errors
              await sendFailureToBackend(err || "Unknown error occurred", "error");
              onFailure?.({ status: "error", reason });
            }}
          onCancel={async (data) => {
            await sendFailureToBackend(data);
            onFailure?.({ status: "cancelled", reason: "User canceled the payment" });
          }}
        />
      ) : (
        <p>Please enter a valid amount to proceed with PayPal.</p>
      )}
    </>
  );
};

export default PayPalButtonUI;
